<ng-container *ngIf="selectorTpl != null; else elseTpl">
  <div (click)="open()">
    <ng-container *ngTemplateOutlet="selectorTpl; context: {item: item}"></ng-container>
  </div>
</ng-container>
<ng-template #elseTpl>
  <ion-item [class.invalid]="isInvalid() && isTouched()">
    <label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label>
    <ion-button fill="clear" slot="end" (click)="open()" class="ion-text-right">
      <ng-container *ngIf="(comboItemTpl == null && displayTpl == null) || value == null">{{(text | async) != null && (text | async) != '' ? (text | async) : placeholder}}</ng-container>
      <ng-container *ngIf="(displayTpl == null && comboItemTpl != null) && value != null">
        <ng-container *ngTemplateOutlet="comboItemTpl; context: {item: item}"></ng-container>
      </ng-container>
      <ng-container *ngIf="(displayTpl != null) && value != null">
        <ng-container *ngTemplateOutlet="displayTpl; context: {item: item}"></ng-container>
      </ng-container>
    </ion-button>
  </ion-item>
</ng-template>
<ion-modal class="modalCustom" #modal (ionModalDidDismiss)="modal.isOpen = false">
  <ng-template>
    <ng-container *ngIf="dataSource != null">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="modal.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
             <!-- <ion-button (click)="modal.dismiss()">{{cancelText}}</ion-button> -->
          </ion-buttons>
          <ion-title>{{modalTitle}}</ion-title>
        </ion-toolbar>
        <ion-toolbar *ngIf="showSearch">
          <ion-searchbar [placeholder]="searchPlaceholder" #searchBar [debounce]="300" (ionInput)="onSearch()"></ion-searchbar>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-list>
          <ng-container *ngIf="(dataSource | async) != null && (dataSource | async).length && (dataSource | async).length > 0; else emptyTpl">
            <div *ngFor="let item of dataSource | async" (click)="optionSelected(item)">
              <ion-item class="itemList" button *ngIf="comboItemTpl == null">
                <ion-label [class.textList]="true" [class.selected]="item != null && item[valueField] != null && item[valueField] == value"><ion-icon name="caret-forward" class="iconLabel mr-2"></ion-icon>{{item != null && item[displayField] != null ? item[displayField] : ''}}</ion-label>
              </ion-item>
              <ng-container *ngIf="comboItemTpl != null">
                <ng-container *ngTemplateOutlet="comboItemTpl; context: {item: item}"></ng-container>
              </ng-container>
            </div>
          </ng-container>
        </ion-list>
        <ion-infinite-scroll *ngIf="dataSource.HasMoreItems | async" (ionInfinite)="onIonInfinite($event)">
          <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
        <ion-refresher #refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
          <ion-refresher-content></ion-refresher-content>
        </ion-refresher>
      </ion-content>
      <ion-footer *ngIf="allowBlank">
        <ion-buttons slot="start">
          <ion-button (click)="optionSelected(null)" color="danger">Limpiar</ion-button>
        </ion-buttons>
      </ion-footer>
    </ng-container>
  </ng-template>
</ion-modal>
<ng-template #emptyTpl>
  <span class="AlertNoResults">{{emptyText}}</span>
</ng-template>